import { Input } from "@/lib/components/Input";
import { Slider } from "@/lib/components/Slider";
import { useEffect, useState } from "react";

type Props = {
  seconds: number;
  onCommitChange: (seconds: number) => void;
  min?: number;
  max?: number;
  step?: number;
};

export default function ElementTransitionSecondInput({
  seconds,
  onCommitChange,
  min = 0,
  max = 100,
  step = 0.1,
}: Props) {
  const [value, setValue] = useState(seconds);

  useEffect(() => {
    setValue(seconds);
  }, [seconds]);

  return (
    <div className="flex w-full items-center gap-4">
      <Input
        className="w-[164px]"
        value={value}
        containerSize="sm"
        leadingComponent={<span className="text-text-secondary">Sec</span>}
        onValidateInternalValue={(e) => {
          let parsedValue = e.target.value;
          parsedValue = parsedValue.replace(",", ".");

          return (
            parsedValue === "" ||
            /^\d*$/.test(parsedValue) ||
            /^\d+\.\d{0,2}$/.test(parsedValue)
          );
        }}
        onValidate={(e) => {
          let parsedValue = e.target.value;
          parsedValue = parsedValue.replace(",", ".");

          return parsedValue === "" || /^\d+(\.\d{0,2})?$/.test(parsedValue);
        }}
        onChange={(e) => {
          let parsedValue = e.target.value;
          parsedValue = parsedValue.replace(",", ".");

          onCommitChange(Number(parsedValue));
        }}
      />
      <Slider
        value={value}
        onValueChange={setValue}
        onValueCommit={(newValue) => {
          setValue(newValue);
          onCommitChange(newValue);
        }}
        min={min}
        max={max}
        step={step}
      />
    </div>
  );
}
